var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconButtonRestart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.96816V5.62566C12 5.28816 11.595 5.12316 11.3625 5.36316L9.2625 7.45566C9.1125 7.60566 9.1125 7.83816 9.2625 7.98816L11.355 10.0807C11.595 10.3132 12 10.1482 12 9.81066V8.46816C14.4825 8.46816 16.5 10.4857 16.5 12.9682C16.5 15.0082 15.1275 16.7332 13.2675 17.2807C12.9525 17.3707 12.75 17.6707 12.75 17.9932C12.75 18.4807 13.215 18.8632 13.6875 18.7207C16.1775 17.9932 18 15.6982 18 12.9682C18 9.65316 15.315 6.96816 12 6.96816Z",
    fill: "#002D62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.9682C7.5 11.9632 7.83 11.0332 8.3925 10.2757C8.6175 9.97566 8.5875 9.56316 8.325 9.29316C8.01 8.97816 7.47 9.00816 7.2 9.36816C6.45 10.3732 6 11.6182 6 12.9682C6 15.6982 7.8225 17.9932 10.3125 18.7207C10.785 18.8632 11.25 18.4807 11.25 17.9932C11.25 17.6707 11.0475 17.3707 10.7325 17.2807C8.8725 16.7332 7.5 15.0082 7.5 12.9682Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconButtonRestart);
export default __webpack_public_path__ + "static/media/Icon_Button_Restart.1ec4cece497568661787a425d2da4ff7.svg";
export { ForwardRef as ReactComponent };